import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import styles from './CategoryBanner.css';

const IPropTypes = {
  imageSrc: PropTypes.string,
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
};

const defaultProps = {
  imageSrc: null,
};

const getImageSizeSuffix = (currentWidth) => {
  const { breakpoints } = constants;
  if (currentWidth <= breakpoints.mobileThreshold) {
    return 'mobile';
  } else if (currentWidth <= breakpoints.smallMaxWidth) {
    return 'sm';
  } else if (currentWidth <= breakpoints.mediumMaxWidth) {
    return 'md';
  }
  return 'lg';
};

const getImageDensitySuffix = () => {
  if (constants.pixelDensity === 1) {
    return '1x';
  }
  return '2x';
};

const getBackgroundImage = (imageSrc) => {
  if (imageSrc !== null) {
    const sizeSuffix = getImageSizeSuffix(ScreenStore.screenWidth);
    const densitySuffix = getImageDensitySuffix();

    return (
      {
        backgroundImage: `url(${imageSrc}-${sizeSuffix}-${densitySuffix}.jpg)`,
      }
    );
  }
  return null;
};

const getContainerHeight = imageSrc => (
  imageSrc === null
    ? styles.containerWithoutImage
    : null
);

const CategoryBanner = props => (
  <div
    className={[styles.container, getContainerHeight(props.imageSrc)].join(' ')}
    style={getBackgroundImage(props.imageSrc)}
  >
    <div className={styles.titleContainer}>
      <h2 className={styles.title} style={{ color: props.textColor }}>
        {props.text}
      </h2>
    </div>
  </div>
);

CategoryBanner.propTypes = IPropTypes;
CategoryBanner.defaultProps = defaultProps;

const WrappedCategoryBanner = observer(CategoryBanner);

export { WrappedCategoryBanner as CategoryBanner };



// WEBPACK FOOTER //
// ./src/pages/product-index/category-banner/CategoryBanner.jsx